import { getAccessToken } from 'utils/getAccessToken';

export const getAuthHeaders = () => {
  const token = getAccessToken();
  return {
    authorization: token ? `Bearer ${token}` : '',
  };
};
